import React, { createContext, useContext } from 'react';
var TenantContext = /*#__PURE__*/createContext(null);
export var useTenantContext = function useTenantContext() {
  var tenantContext = useContext(TenantContext);
  if (tenantContext === null) {
    throw new Error('tenantContext value is null');
  }
  return tenantContext;
};
export var TenantContextProvider = function TenantContextProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  if (!value) {
    throw new Error('TenantContextProvider requires a value');
  }
  return /*#__PURE__*/React.createElement(TenantContext.Provider, {
    value: value
  }, children);
};